<template>
  <v-dialog content-class="timeup-dialog" v-model="dialog" @keydown.esc="close" persistent>
    <div class="d-container">
      <v-icon v-if="$store.state.Pad.timeRemain > 0" @click="close" class="d-close-button">mdi-close-circle</v-icon>
      <img v-if="backgroundSrc" :src="backgroundSrc" class="d-background" />
      <div class="d-body">
        <div class="timeup-message">{{ $t("PAD.min_remain", { minute: $store.state.Pad.timeRemain }) }}</div>
      </div>
      <div v-if="$store.state.Pad.timeRemain == 0" class="d-bottom">
        <v-btn color="primary" @click="checkout">{{ $t("checkout") }}</v-btn>
        <v-btn color="primary" @click="home">{{ $t("PAD.home") }}</v-btn>
      </div>
    </div>

    <InputDialog password ref="inputDialog"></InputDialog>
  </v-dialog>
</template>

<script>
import mApp from "@/modules/app";
//import mUtils from "@/modules/utils";

import mDialog from "@/modules/dialog";
import InputDialog from "@/dialogs/InputDialog";

export default {
  components: {
    InputDialog,
  },

  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,

      refreshing: false,
    };
  },

  computed: {
    backgroundSrc() {
      let src;
      if (this.$store.getters.padTableSchema && this.$store.getters.padTableSchema.background)
        src = this.$store.getters.padTableSchema.background.src;
      return src;
    },
  },

  methods: {
    open() {
      this.refreshing = false;
      this.dialog = true;

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    close() {
      if (this.resolve) this.resolve(false);
      this.dialog = false;
    },

    checkout() {
      this.$store.dispatch("PAD_SEND_MESSAGE", "checkout");
      mDialog.messageDialog.open("Message was sent");
    },

    async home() {
      if (!await mApp.checkNetworkStatus()) return;  
      
      let inputRes = await this.$refs.inputDialog.open(this.$t("enter_your_password"));
      if (inputRes) {
        let resp_verify = await mApp.verifyAppPin({ appPin: inputRes });
        if (resp_verify?.result == "ok") {
          this.close();

          this.$emit("home");
        }
      }
    },
  },
};
</script>

<style lang="scss">
.timeup-dialog {
  height: 90vh !important;
  width: 80vw !important;

  .d-container {
    background-color: white;
    display: flex;

    width: 100%;
    height: 100%;

    position: relative;
    overflow: hidden;

    .d-close-button {
      position: absolute;
      top: 12px;
      right: 12px;
      z-index: 1;

      color: var(--v-primary-base);
      font-size: 2.4em;
    }

    .d-background {
      position: absolute;
    }

    .d-body {
      position: relative;
      overflow: scroll;
      margin-top: 64px;
      padding: 0px 64px;
      width: 100%;

      .timeup-message {
        position: absolute;
        top: 250px;
        left: 100px;
        color: var(--v-primary-base);
        font-size: 2em;
      }
    }

    .d-bottom {
      position: absolute;
      bottom: 0px;

      width: 100%;
      padding: 0px 60px 40px 60px;

      display: flex;
      justify-content: space-between;
      align-items: center;

      .v-btn {
        font-size: 1.2em;
        min-width: 300px;
        padding: 24px;
      }
    }
  }
}
</style>
